@import '@atc/axl-atc/scss/variables';

:host {
    --btn-primary-color: #{$btn-primary-color};
    --btn-primary-bg: #{$btn-primary-bg};
    --brand-primary: #{$btn-primary-color};
    --brand-accent: #{$brand-accent};
    --text-color-accent: #{$text-color-accent};
    --link-color: #{$link-color};
    --link-hover-color: #{$link-hover-color};
    --link-hover-decoration: #{$link-hover-decoration};

    --border-radius-base: #{$border-radius-base};
    --btn-border-radius-base: #{$btn-border-radius-base};

    --font-family-webfonts: #{$font-family-webfonts};
    --font-family-base: #{$font-family-base};
    --font-family-serif: #{$font-family-serif};

    --headings-font-family: #{$headings-font-family};
    --headings-color: #{$headings-color};
    --headings-font-weight: #{$headings-font-weight};
    --headings-line-height: #{$headings-line-height};

    // eLot Spacing System - CSS Custom Properties (ATC brand defaults)
    --elot-spacing-xs: 0.25rem;
    --elot-spacing-sm: 0.5rem;
    --elot-spacing-md: 1rem;
    --elot-spacing-lg: 1.5rem;
    --elot-spacing-xl: 2rem;

    // Default container padding (maintains backward compatibility with Bootstrap)
    --elot-container-padding: 8px;
}